const FormBlockFields = {
  formKey: {
    type: "custom",
    label: "Form",
    metadata: {
      source: "manual",
      description: "Which of the business's forms this block renders",
    },
  },
  heading: {
    type: "text",
    label: "Heading",
    metadata: {
      source: "manual",
      description: "Optional heading above the form",
    },
  },
  subheading: {
    type: "textarea",
    label: "Subheading",
    metadata: {
      source: "manual",
      description: "Optional supporting line under the heading",
    },
  },
  submitButtonText: {
    type: "text",
    label: "Submit button",
    metadata: {
      source: "manual",
      description: "Submit button label (defaults to Send Message)",
    },
  },
  successMessage: {
    type: "text",
    label: "Success message",
    metadata: {
      source: "manual",
      description: "Shown after a successful submission",
    },
  },
  anchorId: {
    type: "text",
    label: "Anchor ID",
    metadata: {
      source: "manual",
      description:
        'Where links land. Defaults to "contact", which is what buttons and nav links point at.',
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background color",
    metadata: {
      source: "manual",
      description: "Optional section background color",
    },
  },
} as const;

export { FormBlockFields };
